"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.$searchPhonebook = exports.$getInitialPhonebook = void 0;
var _oldHttpClient = require("../../apiClient/oldHttpClient");
var base = '/phone-book';
var $searchPhonebook = (query, type) => (0, _oldHttpClient.getAxiosProvider)()({
  method: 'get',
  url: "".concat(base, "/"),
  params: {
    search: (query === null || query === void 0 ? void 0 : query.length) > 0 ? query : undefined,
    type
  }
});

// deprecated, use $searchPhonebook instead
exports.$searchPhonebook = $searchPhonebook;
var $getInitialPhonebook = () => $searchPhonebook();
exports.$getInitialPhonebook = $getInitialPhonebook;